import { render, staticRenderFns } from "./linkOrder.vue?vue&type=template&id=6dcfd33c&"
import script from "./linkOrder.vue?vue&type=script&lang=js&"
export * from "./linkOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports